<template>
  <NuxtLink
    class="listing-product-search"
    :to="
      localePath({
        name: 'product-slug',
        params: {
          slug: props.product.slug,
        },
      })
    "
  >
    <div class="listing-product-search__image">
      <img
        v-if="props.product.Immagine_Listing && props.product.title"
        :src="props.product.Immagine_Listing"
        :alt="props.product.title"
      />
    </div>
    <div class="listing-product-search__content">
      <p
        v-if="props.product.title"
        v-html="props.product.title"
        class="listing-product-search__content__title text-big is-medium-bold"
      />

      <div v-if="props.product.Sezione_BIO" class="text-small bio">
        <p
          v-for="(item, index) in props.product.Sezione_BIO"
          :key="index"
          v-html="$t('product.' + item)"
        />
      </div>

      <div
        v-if="localizedDescrizioneProdotto"
        v-html="localizedDescrizioneProdotto"
        class="listing-product-search__content__description text-xsmall"
      />
    </div>
  </NuxtLink>
</template>

<script setup>
const props = defineProps({
  product: Object,
})

const { locale } = useI18n()
const getLocalizedField = (field) => {
  switch (locale.value) {
    case 'en':
      return props.product[`${field}_EN`]
    case 'es':
      return props.product[`${field}_ES`]
    case 'fr':
      return props.product[`${field}_FR`]
    default:
      return props.product[`${field}_IT`]
  }
}

const localizedDescrizioneProdotto = computed(() =>
  getLocalizedField('Descrizione_Prodotto'),
)
</script>

<script>
export default {
  name: 'ListingProductSearch',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
